import request from '@/api/request'

/**
 * 获取 项目表列表
 * @param page
 * @param limit
 */

export const getPageList = (data) => {
  return request({
    url: 'product/adm/project/page',
    data,
    method: 'post',
    type: 'json'
  })
}

/**
 * 添加接口
 *  id  主键
 *  projectName  项目名称
 *  status  1启用2停用
 *  sortNum  排序号
 *  remarks  备注
 *  insertBy  创建者，如果为系统初始数据填0
 *  insertDate  创建时间
 *  lastUpdateBy  最后更新者，如果为系统初始数据填0
 *  lastUpdateDate  最后更新时间
 *  delFlag  逻辑删除标记（1：显示；2：删除）
 *  version  版本号
 * */
export const addProject = (data) => {
  return request({
    url: 'product/adm/project/add',
    data,
    method: 'post',
    type: 'json'
  })
}

/**
 * 更新接口
 * * id  主键
 * * projectName  项目名称
 * * status  1启用2停用
 * * sortNum  排序号
 * * remarks  备注
 * * insertBy  创建者，如果为系统初始数据填0
 * * insertDate  创建时间
 * * lastUpdateBy  最后更新者，如果为系统初始数据填0
 * * lastUpdateDate  最后更新时间
 * * delFlag  逻辑删除标记（1：显示；2：删除）
 * * version  版本号
 * *
 */
export const updateProject = (data) => {
  return request({
    url: 'product/adm/project/update',
    data,
    method: 'post',
    type: 'json'
  })
}
